import React, { useState, useEffect } from 'react';
import Config from '../../../../../Config';
import { prepareUrl } from '../../../../../utilities/StringHelpers/StringHelpers';
import noImage from './images/no-image.png';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import CheckBox from '../../../../Shared/CheckBox/Checkbox';
import { isMobile, isTablet } from 'react-device-detect';
import ChannelsSwiper from './channelsSwiper/channelsSwiper';
//--------------- Swiper ---------------
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper/core';
import checkIcon from './images/icon-checkmark.svg';
import 'swiper/swiper.scss';
SwiperCore.use([Autoplay, Pagination, Navigation]);
//--------------- Swiper ---------------
import Image from 'app/Components/Shared/Image/image';
const PremiumPackagePopup = (props) => {
  const [selectedVas, setSelectedVas] = useState(null);
  const [openPackageDetails, setOpenPackageDetails] = useState([]);
  const [termsLink, setTermsLink] = useState([]);

  console.log('premium package popup props: ', props);

  useEffect(() => {
    if (props.premiumPackage.isPremiumPackagesWorld) {
      const selectedPackages = props.premiumPackage.premiumPackages.filter(x => x.action.toUpperCase() == "ADD");
      const selectedPackagesName = selectedPackages?.map((item, index) => { return item.name });
      if (props.premiumPackage.cmsData?.isSingleChoice) {
        setSelectedVas(selectedPackages.length > 0 ? [selectedPackages[0].name] : []);
      } else {
        setSelectedVas([selectedPackagesName]);
      }
      selectedPackages?.map((item) => {
        setSelectedTermsLink(item, true, true, false);
      });
    }
    else {
      const selectedVas = props.premiumPackage.action.toUpperCase() == "ADD" ? props.premiumPackage : props.premiumPackage.vasList?.find(x => x.action.toUpperCase() == "ADD");
      if (selectedVas) {
        setSelectedVas([selectedVas.name]);
        setSelectedTermsLink(selectedVas, true, false, props.premiumPackage.vasList);
      }
      else {
        if (!props.premiumPackage.vasList) {
          setSelectedTermsLink(props.premiumPackage, true, false, false);
        }
        else {
          setSelectedTermsLink(props.premiumPackage, false, false, true);
        }
      }
    }
  }, []);


  function openCloseDetails(selectedItem) {
    if (openPackageDetails.find(x => x == selectedItem)) {
      setOpenPackageDetails((products) => products.filter((item, index) => item !== selectedItem));
    }
    else {
      setOpenPackageDetails([...openPackageDetails, selectedItem]);
    }
  }

  async function onClickCheckbox(selectedVas, isChecked) {
    const isSingleChoice = props.premiumPackage.cmsData?.isSingleChoice;

    if (props.premiumPackage.isPremiumPackagesWorld) {
      if (isSingleChoice && isChecked) {
        const currentlySelected = props.premiumPackage.premiumPackages.filter(
          x => x.action.toUpperCase() == "ADD" && x.name !== selectedVas.name
        );
        for (const item of currentlySelected) {
          setSelectedTermsLink(item, false);
        }
        await props.onSingleChoiceWorldSwitch(currentlySelected, selectedVas.name);
      } else {
        props.onPremiumPackagesWorldChange(isChecked, selectedVas.name);
      }
    }
    if (isChecked) {
      setSelectedVas([selectedVas.name]);
      setSelectedTermsLink(selectedVas, true, props.premiumPackage.isPremiumPackagesWorld, props.premiumPackage.vasList);
    }
    else {
      setSelectedVas((vas) => vas.filter((item, index) => item !== selectedVas.name))
      setSelectedTermsLink(selectedVas, false);
    }
  }

  function setSelectedTermsLink(premiumPackage, isSelected, isPremiumPackagesWorld, isRoutes) {
    if (isSelected) {
      if (premiumPackage?.cmsData?.termsLink && premiumPackage?.cmsData?.termsLink != "") {
        const title = premiumPackage?.cmsData?.title ? premiumPackage?.cmsData?.title : premiumPackage.localizedName;
        if (isPremiumPackagesWorld) {
          setTermsLink(oldArray => [...oldArray, { title: 'לצפייה בתקנון ' + title, terms: premiumPackage?.cmsData?.termsLink }]);
        }
        else if (isRoutes) {
          setTermsLink([{ title: 'לצפייה בתקנון ' + title, terms: premiumPackage?.cmsData?.termsLink }]);
        }
        else {
          setTermsLink([{ title: 'לצפייה בתקנון', terms: premiumPackage?.cmsData?.termsLink }]);
        }
      }
    }
    else {
      setTermsLink(termsLink.filter((item, index) => item.terms !== premiumPackage?.cmsData?.termsLink))
    }
  }


  function openTermsInNewTab(e, terms) {
    e.preventDefault();
    if (terms) {
      prepareUrl(`${terms}`, props.context);
    }
  }

  function getPrice(item){
    let price = item.price;
    if(item.priceItemList?.length > 0){
      price = item.priceItemList[0].price;
    }
    return(<div className='price-wrapper'>
    <div className="price">₪{price}</div>
    {item.duration.amount == "0" ?
        <div className="period-time"></div> :
        <div className="period-time">חד פעמי</div>
    }
    </div>)
  }

  function getPriceDetails(item){
    if(item.priceItemList?.length > 0){
      return (<div className='price-wrapper'>
        {item.priceItemList.map((item, index) => {
          return (
            <div className='price-row' key={index}>
              {index == 0 && <sapn className='text'>מחיר {item.priceTextPremiumPackages} </sapn>}
              {index != 0 && <span className='text'> {item.priceTextPremiumPackages} { '₪' + item.price } לחודש</span>}
              &nbsp;
            </div> )
        })}
      </div>)
    }else if(item.price != item.originalPrice){
      const isMonthsPeriod = item.duration == "" ;
      return (<div className='price-wrapper'>
        <div className='price-row'> {isMonthsPeriod ? " מחיר לחודש במקום" : "במקום "}<span className='original-price'>₪<sapn className="price">{item.originalPrice}</sapn></span> {isMonthsPeriod ? "לחודש " : ""}</div>
      </div>)
    }
  }

  return (
    <div className="premium-package-popup">
      {props.premiumPackage.vasList?.length > 0 ? (
        <h2> בחרו את {props.premiumPackage.cmsData?.title ? props.premiumPackage.cmsData?.title : props.premiumPackage.billDescription} שמתאימה לכם </h2>
      ) : (
        <h2> {props.premiumPackage.cmsData?.title ? props.premiumPackage.cmsData?.title : props.premiumPackage.billDescription} </h2>
      )
      }
      {props.premiumPackage.vasList?.length > 0 &&
        <div className='vases-checkboxes-wrapper'>
          {props.premiumPackage.vasList.map(function (item, index) {
            const label = item.cmsData?.title ? item.cmsData?.title : item.localizedName;
            const isChecked = selectedVas?.find(x => x == item.name);
            return (
              <div key={index} className="vas-list" >
                  <div className="checkbox-wrapper">
                  <div className='right-details'>
                    <CheckBox checked={isChecked} label={label} id={item.name} onChange={() => onClickCheckbox(item, !isChecked)}>
                    </CheckBox>
                    {getPriceDetails(item)}
                  </div>
                  <div className='left-details'>
                    {getPrice(item)}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      }
      {props.premiumPackage.isPremiumPackagesWorld &&
        <div className='premium-packages-checkboxes-wrapper'>
          {props.premiumPackage.premiumPackages.map(function (item, index) {
            const label = item.cmsData?.title ? item.cmsData?.title : item.localizedName;
            const isChecked = props.premiumPackage.cmsData?.isSingleChoice
              ? !!selectedVas?.find(x => x == item.name)
              : item.action.toUpperCase() == "ADD";
            const isDetailsOpen = openPackageDetails.find(x => x == item.name);
            return (<div key={index} className={`sub-package ${isDetailsOpen ? 'checked' : ''}`} >
              <div className='checkbox-wrapper' >
                <div className='right-details'>
                  <CheckBox
                    key={index}
                    label={label}
                    checked={isChecked}
                    id={item.name}
                    onChange={() => onClickCheckbox(item, !isChecked)}
                  />
                  {getPriceDetails(item)}
                </div>
                <div className='left-details'>
                  {getPrice(item)}
                  <div className='arrow-wrapper' onClick={() => { openCloseDetails(item.name) }}>
                    <i className={`arrow ${isDetailsOpen ? 'up' : 'down'}`}></i>
                  </div>
                </div>
              </div>
              {openPackageDetails.find(x => x == item.name) &&
                <div className="package-details">
                  {item.cmsData?.channels?.length > 0 && <ChannelsSwiper channels={item.cmsData.channels} />}
                  <p>{item.cmsData.description}</p>
                </div>
              }
            </div>)
          })}
        </div>
      }
      {props.premiumPackage.cmsData?.channels?.length > 0 &&
        <div className='channels-wrapper'>
          <h3>הערוצים הכלולים בחבילה</h3>
          <Swiper centeredSlidesBounds={true} centeredSlides={true} enabled={props.premiumPackage.cmsData?.channels.length > 4} autoplay={{ delay: 0, disableOnInteraction: false }} slidesPerView={isMobile ? '2.5' : '4'} speed={4000} setWrapperSize={true} loop={props.premiumPackage.cmsData?.channels.length > 4} >
            {
              props.premiumPackage?.cmsData?.channels?.map(function (item, index) {
                const channelImage = Config.epiBaseUrl + item.image;
                return (
                  <SwiperSlide key={index}>
                    <div className="channel">
                      <div className="channel-image"> <Image src={channelImage} alt={item.channelName}></Image> </div>
                      <div className="channel-name"> {item.channelName} </div>
                    </div>
                  </SwiperSlide>
                );
              })
            }
          </Swiper>
        </div>
      }
      <div className='info-wrapper'>
        <h3 className=''>{props.premiumPackage.cmsData?.popUpInfo?.titleInfo}</h3>
        {props.premiumPackage.cmsData?.popUpInfo?.infoList?.map(function (item, index) {
          return (
            <p key={index} className='info-line'><span className='info-text'> 
                <Image src={checkIcon} alt="check" className="icon-checkmark" />
                {item}
             </span>
            </p>
          )
        })
        }
        <p>{props.premiumPackage.cmsData?.popUpInfo?.info}</p>
        {termsLink?.map(function (item, index) {
          return (
            <a href="#" className='terms-link' onClick={(e) => openTermsInNewTab(e, item.terms)} >{item.title}</a>
          )
        })
        }
      </div>
      <div className='btn-wrapper'>
        {(props.premiumPackage.isPremiumPackagesWorld || props.premiumPackage.vasList?.length > 0) ?
          <>
            <button className='close-btn' onClick={() => { props.closePopUp() }} >חזרה</button>
            <BtnSubmit text={'בחרתי, אפשר להתקדם'} onclick={() => { props.onVasSelected(selectedVas) }} />
          </> :
          <BtnSubmit text={'סגור'} onclick={() => { props.closePopUp() }} />}
      </div>

    </div>
  )

}

export default PremiumPackagePopup;
